module.exports = __webpack_public_path__ + "img/Promoters_16@2x.22a939a0.png";